
import styles from "./ExpensesOrder.module.scss";
import { useTranslation } from 'react-i18next'
import { Button } from 'components'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import numberToWordsRu from 'number-to-words-ru';

import userInfo from "utils/userInfo";

const ExpensesOrder = ({ setOpenModalOrder, item, organization }) => {
    const { t } = useTranslation('common')

    const componentRef = useRef();
    const user = userInfo();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    function numberToSomText(amount) {
        const [som, tiyin] = (amount ?? 0).toString().split(".");

        let somText = numberToWordsRu.convert(Number(som), {
            showCurrency: false,
            currency: false,
        });

        somText = somText.replace(/руб(ль|ля|лей)?/gi, "").replace(/коп(ейка|ейки|еек)?/gi, "");

        somText = somText.replace(/\b\d+\b/g, "");

        somText = somText.replace(/\s{2,}/g, " ").trim();

        somText = somText.charAt(0).toUpperCase() + somText.slice(1);

        somText = `${somText} сом`;

        const tiyinText = (tiyin ? tiyin.padEnd(2, "0") : "00");

        return `${somText} ${tiyinText} тыйын`;
    }

    const directorName = organization?.director_name || item?.director_name || "_____________________";
    const directorPosition = organization?.director_position || t('pages.employeeWizard.position_lbl', 'Должность');

    return (

        <div className={`${styles.div_print_selection} unv-form-card`}>
            <div className={styles.toolbar}>
                <div className={styles.toolbarHead}>
                    <h3 className={`${styles.toolbarTitle} unv-form-card__title`}>
                        {t('auto.components_expensesorder.k3', 'Расходный кассовый ордер')}
                    </h3>
                    <p className={`${styles.toolbarSubtitle} unv-form-card__subtitle`}>
                        {t('auto.expensesorder.subtitle', 'Унифицированная форма КО-2 — предпросмотр для печати')}
                    </p>
                </div>
                <div className={styles.toolbarActions}>
                    <button type="button" className={`${styles.btn_print} unv-btn unv-btn--ghost`} onClick={handlePrint}>
                        {t('auto.components_academicyearcontent.k1', 'Печать')}
                    </button>
                    <Button
                        onClick={() => setOpenModalOrder(false)}
                        className={`${styles.close_btn_sub} unv-btn`}
                    >
                        {t('auto.expensesorder.close', 'Закрыть')}
                    </Button>
                </div>
            </div>
            <div ref={componentRef} className={styles.formWrapper}>
                <div className={styles.docInfo} style={{ width: "100%", justifyContent: "end" }}>
                    Унифицированная форма КО-1 Утверждена постановлением <br></br>
                    Нацстаткомитета Кыргызской Ресспублики от 07.04.2003 №4
                </div>
                <div className={styles.docInfo_header}>

                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th className={styles.table_th}></th>
                                <th>{t('auth.code')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className={styles.table_th}>{t('auto.components_expensesorder.k1')}</td>
                                <td>0310001</td>
                            </tr>
                            <tr>
                                <td className={styles.table_th}>{t('auto.components_expensesorder.k2')}</td>
                                <td>05965896</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h2 className={styles.title}>{t('auto.components_expensesorder.k3')}</h2>
                <div className={styles.docInfo_title}>
                    <div>
                        <h3 className={styles.title}>{t('auto.components_expensesorder.k4')}</h3>
                        <h4 className={styles.title}>{t('auto.components_expensesorder.k5')}</h4>
                    </div>
                    <div>
                        <h4 className={styles.title}>_____________________________</h4>
                        <h4 className={styles.title}>{t('auto.components_expensesorder.k6')}</h4>
                    </div>
                </div>
                <div className={styles.docInfo}>
                    <div>{t('auto.expensesorder.doc_number', 'Номер документа')}: <strong>{item.order}</strong></div>
                    <div>{t('auto.expensesorder.doc_date', 'Дата составления')}: <strong>{item.date_сreate}</strong></div>
                </div>

                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>{t('auto.components_expensesorder.k7')}</th>
                            <th>{t('auto.components_expensesorder.k8')}</th>
                            <th>{t('auto.components_expensesorder.k9')}</th>
                            <th>{t('auto.components_expensesorder.k10')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className={styles.table_in_td}>
                                <table className={styles.table_in}>
                                    <thead>
                                        <tr>
                                            <td>{t('auto.components_expensesorder.k11')}</td>
                                            <td>{t('auto.components_expensesorder.k12')}</td>
                                            <td>{t('auto.components_expensesorder.k13')}</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td ></td>
                                            <td>{item.check}</td>
                                            <td></td>
                                        </tr>

                                    </tbody>
                                </table>
                            </td>
                            <td>1110</td>

                            <td>{item.amount}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>

                <p><strong>{t('auto.components_expensesorder.k14')}</strong> {item.recipient}</p>
                <br></br>
                <p><strong>{t('pages.ordersPage.ground_field')}</strong> {item.check_base}</p>

                <p><strong>{t('auto.components_expensesorder.k15')}</strong> {numberToSomText(item.amount)}</p>
                <br></br>
                <p><strong>{t('auto.components_expensesorder.k16')}</strong> _______________________________</p>
                <br></br>
                <div className={styles.container}>
                    <div className={styles.section}>
                        <h4 className={styles.title_footer}>{t('auto.components_expensesorder.k17')}</h4>
                        <div>
                            <div className={styles.row}><span>{t('pages.employeeWizard.position_lbl')}</span> {directorPosition}</div>
                            <div className={styles.row}><span>{t('auto.components_expensesorder.k18')}</span> _____________</div>
                            <div className={styles.row}><span>{t('auto.components_expensesorder.k19')}</span> {directorName}</div>
                        </div>
                    </div>

                    <div className={styles.section}>
                        <h4 className={styles.title_footer}>{t('auto.components_expensesorder.k20')}</h4>
                        <div>
                            <div className={styles.row}><span>{t('auto.components_expensesorder.k18')}</span> _____________</div>
                            <div className={styles.row}><span>{t('auto.components_expensesorder.k19')}</span> {user.surName} {user.firstName}</div>
                        </div>
                    </div>

                    <div className={styles.section_on}>
                        <h4 className={styles.title_footer}>{t('auto.components_expensesorder.k21')}</h4>
                        <div>
                            <div className={styles.row}><span>{t('auto.components_expensesorder.k15')}</span> {numberToSomText(item.amount)}</div>
                            <div className={styles.row}><span>{t('auto.components_expensesorder.k18')}</span> _____________</div>
                        </div>
                    </div>
                    <div className={styles.section_footer}>
                        <h4 className={styles.title_footer}>{t('pages.studentsTab.to_th')}</h4>
                        <div>
                            <div className={styles.row}> _____________________________________________________________________________________</div>
                            <div className={styles.row}>{t('auto.components_expensesorder.k22')}</div>
                        </div>

                    </div>

                    <br></br>
                    <div className={styles.section}>
                    </div>
                    <div className={styles.section}>

                        <h4 className={styles.title_footer}>{t('auto.components_expensesorder.k23')}</h4>
                        <div>
                            <div className={styles.row}><span>{t('auto.components_expensesorder.k18')}</span> _____________</div>
                            <div className={styles.row}><span>{t('auto.components_expensesorder.k19')}</span> {user.surName} {user.firstName}</div>
                        </div>
                    </div>
                </div>


            </div>


        </div >


    );
};

export default ExpensesOrder;
